import type { ProductEntitlement } from '../types/entitlements';

export type AccessState = 'open' | 'request' | 'requested' | 'notOnPlan' | 'adminNoRole';

export function holdsRoleFor(roles: readonly string[] | null | undefined, productKey: string): boolean {
  const prefix = `${productKey}-`;
  return (roles ?? []).some((slug) => slug.startsWith(prefix));
}

export function canOpen(
  productKey: string,
  entitlement: ProductEntitlement | undefined,
  roles: readonly string[] | null | undefined,
): boolean {
  if (entitlement?.status !== 'active') return false;
  return !entitlement.roleBasedAccess || holdsRoleFor(roles, productKey);
}

export function accessStateFor({ productKey, entitlement, roles, openRequests, isOrgAdmin }: {
  productKey: string;
  entitlement: ProductEntitlement | undefined;
  roles: readonly string[] | null | undefined;
  openRequests: ReadonlySet<string>;
  isOrgAdmin: boolean;
}): AccessState {
  if (entitlement?.status !== 'active') return 'notOnPlan';
  if (canOpen(productKey, entitlement, roles)) return 'open';
  if (isOrgAdmin) return 'adminNoRole';
  return openRequests.has(productKey) ? 'requested' : 'request';
}
